const translations = {
    ADD_PRODUCT_FAMILY: "הוסף משפחת מוצר",
    REFRESH_DATA: "רענן נתונים",
    ADD_SUCCESS: "משפחת המוצר נוספה בהצלחה",
    ADD_PRODUCT_FAMILY_SUCCESS: "הוסף משפחת מוצר בהצלחה",
    LOADING_ERROR: "שגיאה בטעינת הנתונים",
    ERROR_OCCURRED: "ארעה שגיאה",
    PLEASE_FILL_DETAILS: "אנא מלא את הפרטים הבאים:",
    CHOOSE_PRODUCT_FAMILY: "בחר משפחת מוצר",
    NO_OPTIONS: "לא נמצאו אפשרויות",
    PRODUCT_FAMILY_CODE: "קוד משפחת מוצר",
    PRODUCT_FAMILY_TYPE: "טיפוס משפחת מוצר",
    ORDER_APPROVAL_REQUIRED: "נדרש אישור הזמנה",
    SELECT_APPROVAL_ROLE: "בחר קבוצת הרשאה...",
    CANCEL: "ביטול",
    ADD: "הוסף",
  };
  
  export default translations;
  